/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from client/pages/terms/marketplace.tsx.
// Do not edit it manually.

import type __GeneratedRouteApp from "@/client/index";

/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';

// Core

// App components
import { Link } from '@client/components';
import Page from '@/client/pages/_layout/_page';

/*----------------------------------
- TABS
----------------------------------*/
const TermsTabs = ({
  current
}: {
  current: 'tools' | 'marketplace' | 'csm' | 'teamLeader' | 'businessPartner' | 'dealPartner' | 'ambassadors';
}) => {
  const base = 'px-4 py-2 rounded-lg text-sm font-semibold transition-colors';
  const active = 'bg-gradient-to-r from-orange-500 to-pink-500 text-white shadow';
  const inactive = 'text-slate-700 hover:text-orange-600 hover:bg-orange-50';
  return <div className="flex flex-wrap items-center gap-2 bg-orange-50 border border-orange-100 rounded-xl p-2">
            <Link to="/terms" className={`${base} ${current === 'tools' ? active : inactive}`}>
                Tools
            </Link>
            <Link to="/terms/marketplace" className={`${base} ${current === 'marketplace' ? active : inactive}`}>
                Marketplace
            </Link>
            <Link to="/terms/csm" className={`${base} ${current === 'csm' ? active : inactive}`}>
                CSM
            </Link>
            <Link to="/terms/team-leader" className={`${base} ${current === 'teamLeader' ? active : inactive}`}>
                Team Leader
            </Link>
            <Link to="/terms/business-partner" className={`${base} ${current === 'businessPartner' ? active : inactive}`}>
                Business Partner
            </Link>
            <Link to="/terms/deal-partner" className={`${base} ${current === 'dealPartner' ? active : inactive}`}>
                Deal Partner
            </Link>
            <Link to="/terms/ambassadors" className={`${base} ${current === 'ambassadors' ? active : inactive}`}>
                Ambassadors
            </Link>
        </div>;
};

/*----------------------------------
- PAGE: MARKETPLACE TERMS
----------------------------------*/

export const __register = (app: __GeneratedRouteApp) => {
  const { Router } = app;
  return Router.page('/terms/marketplace', { ...({
  static: {
    refresh: '1h',
    urls: ['/terms/marketplace']
  }
}), ...{ filepath: "/app/client/pages/terms/marketplace.tsx", sourceLocation: { line: 54, column: 1 }, id: "terms_marketplace" } }, null, ({}) => {
  const placeholderClassName = 'font-bold text-slate-900';
  return <Page mainClassName="pt-28 pb-20 px-6 lg:px-8 bg-gradient-to-br from-orange-50 via-white to-pink-50">
            <div className="max-w-[920px] mx-auto">
                <div className="mb-6">
                    <TermsTabs current="marketplace" />
                </div>

                <div className="bg-white rounded-2xl shadow-lg border border-orange-100 p-8 md:p-10">
                    <h1 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent mb-6">
                        Free Recruiter Agreement
                    </h1>

                    <div className="prose prose-slate max-w-none">
                        <header className="mb-6">
                            <p className="text-slate-700 mb-0">
                                This Free Recruiter Agreement (hereinafter referred to as the “Agreement”) is entered
                                into as of <span className={placeholderClassName}>[DATE]</span>, between:
                            </p>
                        </header>

                        <section className="not-prose border border-slate-200 rounded-xl p-4 bg-slate-50 mb-8" aria-label="Parties">
                            <dl className="text-slate-800">
                                <dt className="font-semibold mt-0">Cross Path Network Ltd</dt>
                                <dd className="ml-0 mt-1">Registered in England with registration number 13863925</dd>
                                <dd className="ml-0 mt-1">
                                    Address: Unit 01.12, 1st Floor, 30 Norman Road, London, SE10 9QX, United Kingdom
                                </dd>
                                <dd className="ml-0 mt-1">(“Cross Path” or the “Company”)</dd>

                                <dt className="font-semibold mt-4">Recruiter</dt>
                                <dd className="ml-0 mt-1">
                                    Name of the Recruiter: <span className={placeholderClassName}>[NAME]</span>
                                </dd>
                                <dd className="ml-0 mt-1">
                                    Address of the Recruiter: <span className={placeholderClassName}>[ADDRESS]</span>
                                </dd>
                                <dd className="ml-0 mt-1">(“Recruiter”)</dd>
                            </dl>
                            <p className="text-slate-600 mt-3 mb-0">Collectively referred to as “the Parties”.</p>
                        </section>

                        <section className="mt-0">
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                1. Purpose of the Agreement
                            </h2>
                            <p className="text-slate-700 mb-0">
                                The purpose of this Agreement is to define the terms and conditions under which the
                                Recruiter accesses recruitment missions on the Cross Path platform, sources and presents
                                candidates, and receives commissions for successful placements.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                2. Nature of the Collaboration
                            </h2>
                            <p className="text-slate-700 mb-0">
                                The relationship established by this Agreement is that of independent contractors.
                                Nothing in this Agreement shall be construed to create a relationship of employer and
                                employee, principal and agent, or joint venture between the Parties.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                3. Responsibilities of the Recruiter
                            </h2>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">
                                3.1 Mission Access and Candidate Presentation
                            </h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>Apply to available recruitment missions on the Cross Path platform.</li>
                                <li>
                                    Await validation by the mission’s Customer Success Manager (CSM) before beginning
                                    sourcing.
                                </li>
                                <li>
                                    Source and present qualified candidates through the platform’s Applicant Tracking
                                    System (ATS).
                                </li>
                                <li>
                                    Present at least one candidate within 14 days of mission validation or face
                                    automatic removal.
                                </li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">
                                3.2 Communication and Compliance
                            </h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>Communicate exclusively through the Cross Path platform with the assigned CSM.</li>
                                <li>Refrain from direct contact with clients unless explicitly authorized.</li>
                                <li>Maintain confidentiality of all information obtained through the platform.</li>
                                <li>
                                    Comply with all applicable laws, including anti-discrimination and data protection
                                    regulations.
                                </li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">3.3 Invoicing Requirement</h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-0">
                                <li>
                                    Upon successful placement, provide Cross Path with a valid invoice to receive
                                    commission payment.
                                </li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                4. Responsibilities of Cross Path
                            </h2>
                            <p className="text-slate-700 mb-4">Cross Path agrees to:</p>
                            <ul className="list-disc pl-6 text-slate-700 mb-0">
                                <li>Provide free access to the recruitment mission board and ATS.</li>
                                <li>
                                    Publish clear mission briefs with requirements, commission structure, and payment
                                    terms.
                                </li>
                                <li>Handle all client contracts, invoicing, and payment collection.</li>
                                <li>Calculate and distribute commissions in accordance with mission terms.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                5. Commission and Payment Terms
                            </h2>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">5.1 Recruiter Commission</h3>
                            <p className="text-slate-700 mb-4">
                                The Recruiter shall be entitled to a commission as specified in each individual
                                recruitment mission.
                            </p>
                            <p className="text-slate-700 mb-6">
                                Only the Recruiter whose candidate is successfully hired shall receive the commission
                                for that placement.
                            </p>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">5.2 Multiple Role Cumulation</h3>
                            <p className="text-slate-700 mb-6">
                                If the Recruiter is also acting as CSM, Business Partner, or Team Leader on the same
                                mandate, commissions from multiple roles may be cumulated as specified in the individual
                                mandate terms.
                            </p>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">5.3 Payment Conditions</h3>
                            <p className="text-slate-700 mb-4">
                                Commission payments will be made only after Cross Path has received the full amount due
                                from the client, and provided no portion is subject to refund or reimbursement.
                            </p>
                            <p className="text-slate-700 mb-0">
                                No commission shall be payable for any mission that does not result in a successful paid
                                placement.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                6. Platform Access
                            </h2>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">6.1 Free Access</h3>
                            <p className="text-slate-700 mb-6">
                                The Recruiter receives free access to the mission board, ATS, and mission briefs. Free
                                access does NOT include CRM, client prospecting tools, automated campaigns, or Deal
                                Partner Radar.
                            </p>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">6.2 Recruiter Access</h3>
                            <p className="text-slate-700 mb-0">The Recruiter receives marketplace access under the applicable recruiter terms.</p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                7. Mission Validation and Removal
                            </h2>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">7.1 CSM Validation</h3>
                            <p className="text-slate-700 mb-6">
                                The Recruiter’s application to a mission must be validated by the CSM before accessing
                                mission details.
                            </p>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">7.2 Automatic Removal</h3>
                            <p className="text-slate-700 mb-6">
                                The Recruiter will be automatically removed from a mission if they fail to present at
                                least one candidate within 14 days of validation.
                            </p>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">7.3 Manual Removal by CSM</h3>
                            <p className="text-slate-700 mb-6">
                                The CSM may manually remove the Recruiter from a mission at any time for poor quality,
                                unresponsiveness, or unprofessional conduct.
                            </p>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">
                                7.4 No Commission Upon Removal
                            </h3>
                            <p className="text-slate-700 mb-0">
                                No commission shall be due for missions from which the Recruiter has been removed,
                                unless a candidate presented before removal is ultimately hired.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                8. Termination of Recruiter Status
                            </h2>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">
                                8.1 Termination for Gross Misconduct
                            </h3>
                            <p className="text-slate-700 mb-4">
                                Cross Path reserves the right to unilaterally terminate the Recruiter’s account in the
                                event of gross misconduct, including:
                            </p>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>Serious breach of confidentiality</li>
                                <li>Fraudulent activity or misrepresentation</li>
                                <li>Violation of anti-discrimination or anti-corruption laws</li>
                                <li>Direct unauthorized contact with clients</li>
                                <li>Actions damaging Cross Path’s reputation</li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">8.2 Consequences</h3>
                            <p className="text-slate-700 mb-0">
                                Upon termination, platform access shall be immediately revoked. Commissions accrued
                                prior to termination remain payable per Section 5.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                9. Confidentiality
                            </h2>
                            <p className="text-slate-700 mb-4">
                                The Parties agree to keep all confidential information obtained during this Agreement
                                strictly confidential and not to disclose it to any third party during or after the term
                                of this Agreement.
                            </p>
                            <p className="text-slate-700 mb-0">
                                These confidentiality obligations shall survive the termination of this Agreement
                                indefinitely.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                10. Duration and Termination
                            </h2>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">10.1 Duration</h3>
                            <p className="text-slate-700 mb-6">
                                This Agreement shall remain in effect until terminated by either Party.
                            </p>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">10.2 Termination Rights</h3>
                            <p className="text-slate-700 mb-6">
                                Either Party may terminate this Agreement at any time by providing written notice.
                            </p>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">
                                10.3 Commissions Upon Termination
                            </h3>
                            <p className="text-slate-700 mb-6">
                                Any commissions accrued prior to termination shall remain payable in accordance with
                                Section 5. “Accrued” means that all conditions necessary for payment have been
                                satisfied.
                            </p>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">10.4 Effect</h3>
                            <p className="text-slate-700 mb-0">
                                Termination does not affect the provisions regarding removal from missions or
                                termination for gross misconduct.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                11. Governing Law and Jurisdiction
                            </h2>
                            <p className="text-slate-700 mb-0">
                                This Agreement shall be governed by and construed in accordance with English law. The
                                Parties irrevocably agree to submit to the exclusive jurisdiction of the English courts.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                12. Miscellaneous
                            </h2>
                            <p className="text-slate-700 mb-4">
                                The Recruiter must promptly report to Cross Path any improper request or activity that
                                could constitute bribery or corruption.
                            </p>
                            <p className="text-slate-700 mb-0">
                                Any amendment to this Agreement must be made in writing and signed by both Parties.
                            </p>
                        </section>

                        {/* Signatures removed */}
                    </div>
                </div>
            </div>
        </Page>;
});
};
